import { Injectable, NgZone } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { KycService } from '../services/kyc.service';
import firebase from 'firebase/compat/app';
import { ModalLoginService } from '../services/modal-login.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class GuardGuard  {
  constructor(
    private authSrv: AuthService,
    private router: Router, 
    private zone: NgZone,
    private kycSrv: KycService,
    private modalLogin: ModalLoginService  ) {}

  goLogin() {
    this.zone.run(() => { this.router.navigate(['/login']); });
  }

  goOportunidades() {
    this.zone.run(() => { this.router.navigate(['/oportunidades']); });
    console.log('goOportunidades');
  }

  goKyc() {
    this.zone.run(() => { this.router.navigate(['/oportunidades']); });
    console.log('goKyc');
  }

  async checkLogin() {
    const loggedIn = await this.authSrv.isLoggedIn();
    //console.log(loggedIn);
    (!loggedIn) ? this.goLogin() : null;
  }

  checkPending2FA() {
    const pending2FA = sessionStorage.getItem('pending2FAAuth');
    if (pending2FA) {
      this.zone.run(() => { this.router.navigate(['/verify-2fa']); });
      return true; // Hay un 2FA pendiente
    }
    return false; // No hay 2FA pendiente
  }

  async checkEmailVerified() {
    await firebase.auth().currentUser?.reload();

    const info = await this.authSrv.userAuth.getValue();
    (info !== null && !info.emailVerified) ? this.authSrv.sendOtherEmailVerification() : null;  
  }

  async checkKyc() {
    const kyc = await this.kycSrv.kycSuccess.getValue();
    
    (!kyc) ? this.goKyc() : null;
  }

  async checkKyc2() {
    const kyc = await this.kycSrv.kycSuccess.getValue();
    
    (kyc) ? this.goOportunidades() : null;
    this.modalLogin.closeModalLogin();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    this.checkLogin();

    // Si el usuario intentó saltarse el 2FA cambiando la URL de manera manual, forzamos la verificación
    if (route.routeConfig?.path !== 'verify-2fa' && this.checkPending2FA()) {
      return false;
    }

    if (
      route.routeConfig?.path !== 'login' && 
      route.routeConfig?.path !== 'documentacion'
    ) {
      this.modalLogin.closeModalLogin();
      this.checkEmailVerified();
    }

    if(route.routeConfig?.path === 'oportunidades') {
      this.checkLogin();   
     }


    if (route.routeConfig?.path === 'mis-inversiones') {
      this.checkLogin();
    }

    // El acceso a 'administracion' lo resuelve AdminGuard, que comprueba el rol
    // contra Firestore. Aqui no se decide con el flag en memoria porque puede
    // reescribirse desde la consola del navegador.

    // if (route.routeConfig?.path === 'kyc') {
    //   this.checkKyc2();
    // }
    
    return true;
  }
  
}
